













































































































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import refiDigitalClientRegisterService from "@/services/RefiDigitalClienteRegisterService";
import CookieConsentService from "@/services/CookieConsentService";

import {APIResponse, RegisterRefiDigitalRequest, RegisterResponse,} from "@/models";
import _moment from "moment";
import {RefiDigitalEnum} from "@/helpers/refi-digital.enum";
import ApiError from "@/models/ApiError";
import ValidationHelper from "@/helpers/ValidationHelper";
import codeGenMetadata from "@/helpers/refi-form";
import Modal from "@/components/Modal.vue";
import {OmniUsuarioEnum} from "@/helpers/omni-usuario.enum";
import {UserRequest} from "@/models/UserRequest";
import userService from "@/services/UserService";
import {ToastOptions} from "vue-toastification/dist/types/src/types";
import {TYPE} from "vue-toastification/dist/types/src/ts/constants";
import VueRecaptcha from "vue-recaptcha";

declare const document: any;

@Component({
  components: {
    Modal,
    VueRecaptcha
  },
})
export default class RegisterRefiDigital extends Vue {
  public EMAIL_REMETENTE: string = process.env.VUE_APP_EMAIL_REMETENTE;
  public finishedRegister: boolean = false;
  public hasQuestion: boolean = false;
  public isOpen = false;
  public name: any = "";
  public email: string = "";
  public confirmEmail: string = "";
  public cellphone: number | null = null;
  public birthDate: string = "";
  public document: string = "";
  public password: string = "";
  public clientId: string =
      localStorage.getItem(OmniUsuarioEnum.OMNI_KEYCLOAK_CLIENTID) ||
      RefiDigitalEnum.OMNI_KEYCLOAK_DEFAULT;
  public isBusy: boolean = false;
  public token: string = "";
  public localErrors: ApiError[] = [];
  public termsLink: string = RefiDigitalEnum.USERS_TERMS;

  public acceptWhatsapp: boolean = false;
  public acceptTermsAndConditions: boolean = false;

  public loginEmAndamento: boolean = false;
  public errorMessage: string = "";
  public registerResponse: RegisterResponse | null = null;
  public typePassword = "password";
  public cookieConsentService: CookieConsentService = new CookieConsentService(
      codeGenMetadata
  );

  public recaptchaSiteKey: string = process.env.VUE_APP_RECAPTCHA_SITE_KEY;
  
  public userResponse: RegisterResponse | any = null;
  public emailReSuccessfullySent: boolean = false;

  @Watch("hasQuestion")
  public watchHasQuestion(newVal: number, oldVal: number) {
    if (newVal && !oldVal) {
      this.isBusy = false;
    }
  }

  /**
   * @param type
   * SUCCESS = "success",
   * ERROR = "error",
   * WARNING = "warning",
   * INFO = "info",
   * DEFAULT = "default"
   */
  public showMessage(message = '', type = 'info') {
    this.$toast.clear();
    const options: (ToastOptions & { type?: TYPE.INFO | undefined } | any) = {
      timeout: false,
      closeOnClick: true,
      pauseOnFocusLoss: true,
      pauseOnHover: true,
      draggable: true,
      draggablePercent: 0.83,
      showCloseButtonOnHover: false,
      hideProgressBar: true,
      closeButton: "button",
      icon: true,
      rtl: false
    }
    switch (type) {
      case 'success' :  this.$toast.success(message, options); break;
      case 'error' : this.$toast.error(message, options); break;
      case 'warning' : this.$toast.warning(message, options); break;
      case 'info' : this.$toast.info(message, options); break;
    }
  }
  
  public showErrorMessage(message = '', error: any, type = 'error') {
    if (error.response && error.response.data && error.response.data.omniSpanId) {
      message += `\n\n OmniSpanId: ${error.response.data.omniSpanId}`;
    }    
    this.showMessage(message, type);
  }

  public validEmail(): boolean {
    const validEmail = ValidationHelper.email(this.email);
    if (!validEmail) {
      this.loginEmAndamento = false;
      this.errorMessage = "Endereço de e-mail inválido.";
      this.showMessage(this.errorMessage);
      return false;
    }
    if (!this.validConfirmEmail()) return false;
    return true;
  }

  public validConfirmEmail(): boolean {
    const email = ValidationHelper.email(this.confirmEmail);
    if (!email) {
      this.loginEmAndamento = false;
      this.errorMessage = "Endereço de e-mail inválido. (Confirme seu e-mail)";
      this.showMessage(this.errorMessage, 'error');
      return false;
    }
    if (this.email != this.confirmEmail) {
      this.errorMessage = "Verifique o e-mail cadastrado, os campos 'E-mail” e “Confirme seu e-mail” devem ser iguais.";
      this.showMessage(this.errorMessage);
      return false;
    }
    return true;
  }

  public checkStrengthPassword(password: string): boolean {
    const numeros = /([0-9])/;
    const alfabeto = /([a-zA-Z])/;
    const chEspeciais = /([~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<])/;
    if (password.length < 8) {
      this.errorMessage = "A senha deve ter no mínimo 8 caracteres.";
      this.showMessage(this.errorMessage, 'error');
      return false;
    }
    if (password.match(numeros) && password.match(alfabeto) && password.match(chEspeciais)) {
      return true;
    } else {
      this.errorMessage = "Senha média, insira um caracter especial, pelo menos 1 letra maiúscula ou minúscula e um número!";
      this.showMessage(this.errorMessage, 'error');
      return false;
    }
  }

  public async sendRegister(event: PointerEvent | any) {
    const eventClick = event;
    eventClick.stopPropagation();

    this.loginEmAndamento = true;
    this.errorMessage = "";
    if (!this.name) {
      document.getElementById("name").focus();
      this.loginEmAndamento = false;
      this.errorMessage = "Preencha o campo (Nome).";
      this.showMessage(this.errorMessage);
      return;
    }

    if(!this.email){
      document.getElementById("email").focus();
      this.loginEmAndamento = false;
      this.errorMessage = "Preencha o campo (E-mail).";
      this.showMessage(this.errorMessage);
      return;
    }

    if(!this.confirmEmail){
      document.getElementById("confirmEmail").focus();
      this.loginEmAndamento = false;
      this.errorMessage = "Preencha o campo (Confirme Seu E-mail).";
      this.showMessage(this.errorMessage);
      return;
    }

    if (!this.validEmail()) return;
    

    if(this.localErrors && this.localErrors.length >= 1){
      this.errorMessage = this.localErrors[0]['message'] as string;
      this.showMessage(this.errorMessage, 'error');
      return;
    }

    if(!this.document){
      document.getElementById("cpf").focus();
      this.loginEmAndamento = false;
      this.errorMessage = "Preencha o campo (CPF).";
      this.showMessage(this.errorMessage);
      return;
    }

    if(!this.birthDate){
      document.getElementById("data-nascimento").focus();
      this.loginEmAndamento = false;
      this.errorMessage = "Preencha o campo (Data de Nascimento).";
      this.showMessage(this.errorMessage);
      return;
    }

    if(!this.cellphone){
      document.getElementById("telefone").focus();
      this.loginEmAndamento = false;
      this.errorMessage = "Preencha o campo (Celular).";
      this.showMessage(this.errorMessage);
      return;
    }

     this.validarCelular(this.cellphone.toString());

    if(!this.password){
      document.getElementById("senha").focus();
      this.loginEmAndamento = false;
      this.errorMessage = "Preencha o campo (Senha).";
      this.showMessage(this.errorMessage);
      return;
    }

    if (!this.acceptTermsAndConditions) {
      this.errorMessage =
          'É necessário concordar com os termos e condições para se cadastrar.';
      this.showMessage(this.errorMessage);
      return;
    }

    if (!this.checkStrengthPassword(this.password)) {
      this.loginEmAndamento = false;
      return;
    }

    const registerRequest: RegisterRefiDigitalRequest = {
      name: this.name.trim(),
      email: this.email,
      cellphone: this.cellphone,
      birthDate: Date.parse(this.parseToDate(this.birthDate)),
      document: this.document,
      password: this.password,
      redirectUri:
          this.mountRedirectURI(
              localStorage.getItem(OmniUsuarioEnum.OMNI_KEYCLOAK_REDIRECTURI)
          ) || "",
      clientId:
          localStorage.getItem(OmniUsuarioEnum.OMNI_KEYCLOAK_CLIENTID) ||
          RefiDigitalEnum.OMNI_KEYCLOAK_DEFAULT,
      acceptSendMessage: this.acceptWhatsapp,
    };

    this.cookieConsentService.uploadConsent();

    /**
     * @description Validação Data de Nascimento
     */
    if (!registerRequest.birthDate) {
      this.loginEmAndamento = false;
      document.getElementById("data-nascimento").focus();
      this.errorMessage = "Preencha corretamente o campo (Data de Nascimento).";
      this.showMessage(this.errorMessage, 'error');
      return;
    }

    /**
     * @description Validação Idade
     */
    const date = new Date(registerRequest.birthDate);
    const currentDate = new Date();
    const age = currentDate.getFullYear() - date.getFullYear();
    if (age < 18) {
      this.loginEmAndamento = false;
      document.getElementById("data-nascimento").focus();
      this.errorMessage = "Você precisa ser maior de idade para continuar com cadastro!";
      this.showMessage(this.errorMessage, 'error');
      return;
    }

    try {
      this.registerResponse = await refiDigitalClientRegisterService.register(
          registerRequest
      );
      if (this.registerResponse.status === APIResponse.EMAIL_ALREADY_IN_USE) {
        this.loginEmAndamento = false;
        this.errorMessage =
            "Não foi possível registrar o usuário pois o e-mail já está em uso.";
        this.showMessage(this.errorMessage);
        return;
      } else if(this.registerResponse.status === APIResponse.USER_ALREADY_EXISTS) {
        this.errorMessage = "Esse CPF já possui cadastro no Portal da Omni, digite a senha cadastrada ou clique em esqueci minha senha.";
        this.showMessage(this.errorMessage);
      }
      this.finishedRegister =
          this.registerResponse.status === APIResponse.SUCCESS;

      if (eventClick) {
        if (eventClick.hasOwnProperty('onClick')) {
          eventClick.onClick();
        }
      }

    } catch (error) {
      this.errorMessage = "Não foi possível realizar o cadastro, Por gentileza entre em contato com nossa Central de Relacionamento.";
      if (error.response.data.status === APIResponse.EMAIL_ALREADY_IN_USE) {
        this.loginEmAndamento = false;
        this.errorMessage = "Não foi possível registrar o usuário pois o e-mail já está em uso.";
      } else if(error.response.data.status === APIResponse.USER_ALREADY_EXISTS) {
        this.errorMessage = "Esse CPF já possui cadastro no Portal da Omni, digite a senha cadastrada ou clique em esqueci minha senha.";
      }
      this.showErrorMessage(this.errorMessage, error, 'warning');
      this.loginEmAndamento = false;
    } finally {
      this.loginEmAndamento = false;
    }
  }

  public openModal() {
    this.isOpen = true;
  }

  public closeModal() {
    this.isOpen = false;
  }

  public validarCpf(cpf: string) {
    this.localErrors = this.localErrors.filter((e) => e.property !== "cpf");
    const erro = { property: "cpf", message: "" };

    if (cpf.length === 0) {
      erro.message = "Informe um CPF.";
      this.localErrors.push(erro);
      return;
    }

    const v = ValidationHelper.cpf(cpf);
    if (v === false) {
      erro.message = "O CPF informado é inválido.";
      this.showMessage(erro.message, 'error');
      this.localErrors.push(erro);
    }
  }

  public validarCelular(telefone: string) {
    this.localErrors = this.localErrors.filter((e) => e.property !== "celular");
    const erro = { property: "celular", message: "O celular informado é inválido." };
    
    if(!ValidationHelper.cellphone(telefone)) {
      this.showMessage(erro.message, 'error');
      this.localErrors.push(erro);
    }
  }

  public parseToDate(date: string): string {
    let fomatedDate = _moment(date, "DD/MM/YYYY").toString();
    return fomatedDate;
  }

  public toggleTypePassword() {
    this.typePassword = this.typePassword ? "" : "password";
  }

  public mountRedirectURI(uri: string | null): string {
    if (!uri) return "";
    const regex = new RegExp(RefiDigitalEnum.REDIRECT_URI);
    return uri.replace(regex, RefiDigitalEnum.REDIRECT_REPLACE);
  }

  public solicitarReenvioEmail() {
    (this.$refs.recaptchaEmail as VueRecaptcha).reset();
    (this.$refs.recaptchaEmail as VueRecaptcha).execute();
  }
  
  public recaptchaEmailValidado(tokenRecaptcha: string) {
    this.reSendEmail(tokenRecaptcha);
  }

  public async reSendEmail(recaptcha: string) {
    if (!this.validEmail()) return;
    const userRequest = {
      document: this.document,
      redirectUri: localStorage.getItem("omni-keycloak-redirectUri"),
      recaptchaResponse: recaptcha,
      clientId:
          localStorage.getItem("omni-keycloak-clientId") === "refi-digital"
              ? "refi-digital"
              : "acerto",
    } as UserRequest;
    try {
      this.userResponse = await userService.resendEmail(userRequest, this.token);
      if (this.userResponse.status === APIResponse.TOKEN_ERROR) {
        this.isBusy = false;
        this.errorMessage =
            "Acesso bloqueado por divergência na validação dos dados cadastrais. Por gentileza entre em contato com nossa Central de Relacionamento: 4004 3500 (Capitais e Regiões Metropolitanas) 0800 701 3500 (Demais Regiões). Atendimento de segunda-feira a sábado das 8h às 20h. SAC: 0800 727 0885 - Atendimento para todos os produtos, 24 horas, 7 dias por semana";
        this.showMessage(this.errorMessage, 'error');
        return;
      }
      if (this.userResponse.status === APIResponse.EMAIL_ALREADY_IN_USE) {
        this.loginEmAndamento = false;
        this.errorMessage =
            "Não foi possível registrar o usuário pois o e-mail já está em uso.";
        this.showMessage(this.errorMessage, 'error');
        return;
      }
      if(this.userResponse.status === APIResponse.INCORRECT_CAPTCHA_RESPONSE) {
        this.loginEmAndamento = false;
        this.errorMessage = "Erro no CAPTCHA. Tente novamente.";
        this.showMessage(this.errorMessage);
        return;
      }
      if (this.userResponse.status === APIResponse.SUCCESS) {
        // E-mail enviado com sucesso
        this.emailReSuccessfullySent = true;
      }
    } catch (error) {
      this.errorMessage = "Não foi possível enviar o e-mail, Por gentileza entre em contato com nossa Central de Relacionamento.";
      this.showErrorMessage(this.errorMessage, error, 'error');	
    } finally {
    }
  }

  @Watch('email')
  public watchEmail(data: string) {
    this.email = data.toLowerCase();
  }

  @Watch('confirmEmail')
  public watchConfirmEmail(data: string) {
    this.confirmEmail = data.toLowerCase();
  }
}
